import { PHPAdress } from "../../../../library-js/php/PHPAdress";

export type JOIN_NEWSLETTER        = "join-newsletter";
export type UNSUBSCRIBE_FROM_NEWSLETTER = "unsubscribe-from-newsletter";
export type RADIO_INFO        = "radio-info";
export type RADIO_NEXT_SONG   = "radio-next-song";

export type SONG = "song";

export type GET_VOTINGS   = "get-votings";
export type SAVE_VOTES = "save-votes";
export type VOTING_RESULTS = "voting-results";



/*__DEFINE_TYPE__*/


export type APIAdress = 

  PHPAdress | 
  RADIO_INFO | 
  RADIO_NEXT_SONG | 
  SONG | 
  
  GET_VOTINGS | 
  SAVE_VOTES | 
  VOTING_RESULTS

  /*__ADD_TYPE__*/
;

export class APIAdresses 
{
  static readonly RADIO_INFO:RADIO_INFO = "radio-info";
  static readonly RADIO_NEXT_SONG:RADIO_NEXT_SONG = "radio-next-song"; 
  static readonly SONG:SONG = "song";

  static readonly VOTINGS:GET_VOTINGS     = "get-votings";
  static readonly SAVE_VOTES:SAVE_VOTES = "save-votes";
  static readonly VOTING_RESULTS:VOTING_RESULTS = "voting-results";

  /*__ADD_DECLARATION__*/
}
